import classnames from "classnames";
import { nb } from "date-fns/locale";
import PropTypes from "prop-types";
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { parseDate } from "../../../utils/date";
import "./TextInput.css";

registerLocale("nb", nb);

export default function TimePickerNative({
  id,
  name,
  label,
  value,
  onChange,
  placeholder,
  validationError,
  disabled,
  timeIntervals = 15,
}) {
  const selected = parseDate(value);

  const handleChange = (date) => {
    const v = date || "";
    const formatedValue =
      date instanceof Date && !Number.isNaN(date.getTime())
        ? date.toISOString()
        : "";
    onChange({
      target: {
        id: id || name,
        name: name || id,
        value: v,
        formatedValue,
      },
    });
  };

  return (
    <div
      className={classnames(
        "mb-3",
        validationError ? { "has-error": validationError } : "",
      )}
    >
      {label && (
        <label className="control-label" htmlFor={id || name}>
          {label}
        </label>
      )}
      <div>
        <DatePicker
          id={id}
          selected={selected}
          onChange={handleChange}
          placeholderText={placeholder}
          locale="nb"
          isClearable
          showTimeSelect
          showTimeSelectOnly
          timeIntervals={timeIntervals}
          timeCaption="Tid"
          dateFormat="HH:mm"
          className="form-control"
          autoComplete="off"
          disabled={disabled}
        />
      </div>
      {validationError && (
        <span className="validation-error">{validationError}</span>
      )}
    </div>
  );
}

TimePickerNative.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  validationError: PropTypes.string,
  disabled: PropTypes.bool,
  timeIntervals: PropTypes.number,
};
